import { create } from 'zustand';

interface UIState {
  // Sidebar state
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;

  // Mobile detection
  isMobile: boolean;
  setIsMobile: (value: boolean) => void;

  // Current conversation (for navigation)
  currentConversationId: string | null;
  setCurrentConversationId: (id: string | null) => void;

  // Processing state (for non-streaming requests)
  isProcessing: boolean;
  setProcessing: (isProcessing: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  // Sidebar
  isSidebarOpen: true,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (open) => set({ isSidebarOpen: open }),

  // Mobile
  isMobile: false,
  setIsMobile: (isMobile) => set({ isMobile }),

  // Current conversation
  currentConversationId: null,
  setCurrentConversationId: (id) => set({ currentConversationId: id }),

  // Processing
  isProcessing: false,
  setProcessing: (isProcessing) => set({ isProcessing }),
}));
